export default {
  title: 'Sign in on your own address',
  description:
    'This address belongs to a partner your account is not part of. To keep your account safe, sign in where you normally do — your email and password work there.',
  continue: 'Continue to {{host}}',
  password_changed: 'Your password was changed.',
};
